export default __webpack_public_path__ + "static/media/sipmenu-pause.144aff61.svg";